import { useTimersStore } from '@btcdirect/stores';

type Callback = (...parameters: Array<string | number>) => Promise<void>;

export const useInterval = () => {
    const start = async (name: string, interval: number, callback: Callback, immediate: boolean = true): Promise<void> => {
        return startTimer(name, interval, interval, callback, immediate ? callback : null);
    };

    const startCountdown = async (name: string, interval: number, callback: Callback): Promise<void> => {
        const timersStore = useTimersStore();

        const countdown = async () => {
            timersStore.setCountdown(name, timersStore.countdowns.get(name) - 1);

            if (timersStore.countdowns.get(name) < 1) {
                stop(name);
                startCountdown(name, interval, callback);
            }
        };

        return startTimer(name, interval, 1000, countdown, callback);
    };

    const startSingleCountdown = (name: string, interval: number, tick: number, callback: Callback): Promise<void> => {
        const timersStore = useTimersStore();

        timersStore.setCountdown(name, interval / 1000);

        const countdown = async () => {
            if (timersStore.countdowns.get(name) > 0) {
                timersStore.setCountdown(name, timersStore.countdowns.get(name) - 1);
            }

            if (timersStore.countdowns.get(name) % (tick / 1000) === 0) {
                await callback();
            }

            if (timersStore.countdowns.get(name) < 1) {
                stop(name);
            }
        };

        return startTimer(name, interval, 1000, countdown, callback);
    };

    const stop = (name: string): void => {
        const timersStore = useTimersStore();
        timersStore.clearTimer(name);
    };

    async function startTimer(name: string, interval: number, tick: number, timerCallback: () => Promise<void>, initialCallback?: Callback): Promise<void> {
        const timersStore = useTimersStore();
        if (!!timersStore.timers.get(name)) {
            return;
        }

        try {
            stop(name); // TODO: Is this needed?

            if (!!initialCallback) {
                await initialCallback();
            }

            timersStore.setCountdown(name, interval / 1000);
            timersStore.setTimer(name, setInterval(timerCallback as TimerHandler, tick));
        } catch (exception) {
            if (!exception || exception.isCancelled) {
                return;
            }

            stop(name);
            return Promise.reject(exception);
        }
    }

    return {
        start,
        startCountdown,
        startSingleCountdown,
        stop
    };
};
